import { render, staticRenderFns } from "./CrisisNotificationBar.vue?vue&type=template&id=edb5d69e&"
import script from "./CrisisNotificationBar.vue?vue&type=script&lang=js&"
export * from "./CrisisNotificationBar.vue?vue&type=script&lang=js&"
import style0 from "./CrisisNotificationBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports